import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import {
	TrackPromotionShare,
	type TrackPromotionShareMutation,
	type TrackPromotionShareMutationVariables,
} from './api.graphql';

type Input = { token: string; placement?: string; algorithm?: string; countryCode: string };

export async function trackPromotionShare(
	{ token, placement, algorithm, countryCode }: Input,
	{ gql: { fetch } }: UtilityContext,
	{
		silent,
	}: {
		// if true, won't throw on error
		silent?: boolean;
	} = {},
): Promise<void> {
	let data: TrackPromotionShareMutation | null | undefined;
	try {
		const result = await fetch<TrackPromotionShareMutation, TrackPromotionShareMutationVariables>({
			query: TrackPromotionShare,
			variables: {
				input: {
					eventType: 'SHARE',
					promotionToken: token,
					placement: placement || null,
					algorithm,
					countryCode,
				},
			},
			rejectOnError: false,
			batched: false,
		});
		({ data } = result);
	} catch (err) {
		if (silent) return;
		throw new Error('Promotion tracking failed', { cause: err });
	}

	if (silent) return;
	if (!data?.trackPromotedEvent.success) {
		throw new Error('Promotion tracking failed');
	}
}
